import { memo } from 'react';
import { useDispatch } from 'react-redux';

import { useCurrentUser } from 'my-core/hooks';
import { useCurrentUserSubscription } from 'my-core/subscription-utils';

import SubscribeCTABanner from './SubscribeCTABanner';

import { toggleLoginForm } from 'my-actions/AppStateActions';

export default memo(function SubscribeCTABannerCtnr({ actionText, ...props }) {
  const currentUser = useCurrentUser();
  const subscription = useCurrentUserSubscription();
  const dispatch = useDispatch();

  return (
    <SubscribeCTABanner
      currentUser={currentUser}
      onSignUp={() => dispatch(toggleLoginForm({ source: 'subscribe_cta_banner', actionText }))}
      subscription={subscription}
      {...props}
    />
  );
});
